export default __webpack_public_path__ + "static/media/yellow_button.45f17232.png";